/**
 * V7-P4A shared loading state (design-language 03 P11 LOADING; registry
 * component.loading-state -- built ONCE so the ~30 divergent inline
 * "Loading" divs stop multiplying). Accessible loading vocabulary:
 * role="status" announces the state to assistive tech; the label is always
 * printed text (never a spinner alone); optional skeleton strips reuse the
 * calm pulse idiom with the reduced-motion guard (02 sec 6).
 *
 * PRESENTATION-ONLY: no fetching, no timers, no business logic.
 */

export interface LoadingStateProps {
  /** Printed loading copy (surfaces may name what is loading). */
  readonly label?: string;
  /** Skeleton strips rendered under the label (0 = text only). */
  readonly lines?: number;
  readonly testId?: string;
}

export default function LoadingState({
  label = 'Loading...',
  lines = 0,
  testId,
}: LoadingStateProps): JSX.Element {
  return (
    <div className="ac-loading" role="status" data-testid={testId}>
      <span className="ac-loading__label">{label}</span>
      {Array.from({ length: lines }, (_, i) => (
        <span className="ac-loading__skel" aria-hidden="true" key={i} />
      ))}
    </div>
  );
}
